import type {Icon} from '@primer/octicons-react'
import {Octicon} from '@primer/react/deprecated'
import styles from './MergeabilityIcon.module.css'
import {clsx} from 'clsx'

type MergeabilityIconProps = {
  icon: Icon
  ariaLabel: string
  iconBackgroundColor: string
}

export function MergeabilityIcon({icon, ariaLabel, iconBackgroundColor}: MergeabilityIconProps) {
  return (
    <div
      className={clsx(
        /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
        `d-flex flex-justify-center flex-items-center mr-2 rounded-2 height-2 width-2 position-absolute`,
        styles.mergeabilityIcon,
      )}
      style={{backgroundColor: iconBackgroundColor}}
    >
      <Octicon className="fgColor-onEmphasis" icon={icon} size={24} aria-label={ariaLabel} />
    </div>
  )
}
